import React from 'react';
import DynamicContactFormProps, { Inputs, FieldConfig } from "./props";
import './dynamic-form.scss';
import { useForm, SubmitHandler, FieldError } from "react-hook-form";
import { HiddenField, TextField, TextareaField, SelectField } from './FieldComponents';

function DynamicContactForm(props: DynamicContactFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    props.onSubmit && props.onSubmit(data)
  };

  const hasError = (fieldKey: string): FieldError | undefined => {
    return errors[fieldKey];
  };

  const getErrorMessage = (fieldKey: string): string | undefined => {
    return errors[fieldKey]?.message;
  };

  // Map for field components
  const fieldComponents = {
    hidden: HiddenField,
    text: TextField,
    textarea: TextareaField,
    select: SelectField,
  };

  const renderField = (key: string, fieldConfig: FieldConfig) => {
    const FieldComponent = fieldComponents[fieldConfig.type as keyof typeof fieldComponents];
    
    if (!FieldComponent) {
      return null;
    }

    return (
      <FieldComponent
        key={key}
        fieldKey={key}
        fieldConfig={fieldConfig}
        register={register}
        error={errors[key]}
        getErrorMessage={getErrorMessage}
        hasError={hasError}
      />
    );
  };
  
  return (
    <form className={`dynamic-form ${props.cssPrefix || ''}`} onSubmit={handleSubmit(onSubmit)}>
      {Object.entries(props.fields).map(([key, field]) =>
        renderField(key as string, field)
      )}

      <div className="dynamic-form__row dynamic-form__row_buttons">
        <input
          disabled={props.submitButton?.isDisabled === true}
          type="submit"
          className="dynamic-form__button dynamic-form__button_submit"
          value={ props.submitButton?.title || 'Submit'}
        />
        { props.clearButton && (
          <input
            type="reset"
            className="dynamic-form__button dynamic-form__button_reset"
            value={props.clearButton?.title || 'Clear' }
          />
        ) }
      </div>
    </form>
  );
}

export default React.memo(DynamicContactForm);
